import { render, staticRenderFns } from "./AddThirdPartyServiceComponent.vue?vue&type=template&id=5ed85c78&"
import script from "./AddThirdPartyServiceComponent.vue?vue&type=script&lang=js&"
export * from "./AddThirdPartyServiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports